import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TreeNode } from 'primeng/api';
import * as _ from 'underscore';
import { ClassificationsService } from 'src/app/shared/services/classifications.service';
import { HttpErrorResponse } from '@angular/common/http';
import { BinderClassificationDetailsChildren, BinderClassificationDtoV2 } from 'src/app/shared/interfaces';
import { Mail } from 'src/app/shared/models/mails/mail';

@Component({
  selector: 'app-classement-modal',
  templateUrl: './classement-modal.component.html',
  styleUrls: ['./classement-modal.component.scss'],
})
export class ClassementModalComponent implements OnInit {
  @Input() courrier: Partial<Mail>;
  @Input() advancedMode = false;
  @Output() closeClassificationSearchModal: EventEmitter<{ classementId: number; classeurId: number; chemiseId: number }> = new EventEmitter();

  // Classments
  public classements: TreeNode[] = [];
  public selectedNode: TreeNode; // to get children
  public selectedClassement: TreeNode;
  public selectedClasseur: TreeNode;
  public selectedChemise: TreeNode;
  public selectedObjetClassement: { classementId: number; classeurId: number; chemiseId: number };
  public loading = true;
  constructor(private classificationsService: ClassificationsService) {}

  ngOnInit(): void {
    this.getClassements(this.courrier.serviceProprietaireId);
  }

  getClassements(serviceId: number): void {
    this.classificationsService
      .fetchFoldersClassificationV2({
        SvcIds: [serviceId],
        IncludePartages: true,
      })
      .subscribe({
        next: (response: BinderClassificationDtoV2[]) => {
          const mappedResponse: (BinderClassificationDtoV2 &
            Partial<{
              label: string;
              data: number;
              key: number;
              expandedIcon: string;
              collapsedIcon: string;
              type: string;
              children: BinderClassificationDetailsChildren[];
            }>)[] = [...response];
          if (mappedResponse?.length > 0) {
            mappedResponse.map((item) => {
              if (item?.actif) {
                item.label = item.code + (item.description ? ' (' + item.description + ')' : '');
                item.data = item.id;
                item.key = item.id;
                item.expandedIcon = 'pi pi-folder-open';
                item.collapsedIcon = 'pi pi-folder';
                item.type = 'classement';
                item.children = [];
                if (item.classeurs && item.classeurs.length > 0) {
                  item.classeurs.map((classeur) => {
                    if (classeur.chemises && classeur.chemises.length > 0) {
                      classeur.children = [];
                      classeur.chemises.map((chemise) => {
                        classeur.children.push({
                          label: chemise.description,
                          data: chemise.id,
                          key: chemise.id,
                          icon: 'pi pi-file',
                          classementId: item.id,
                          classeurId: classeur.id,
                          type: 'chemise',
                        });
                      });
                    }
                    item.children.push({
                      label: classeur.description,
                      data: classeur.id,
                      key: classeur.id,
                      expandedIcon: 'pi pi-folder-open',
                      collapsedIcon: 'pi pi-folder',
                      classementId: item.id,
                      type: 'classeur',
                      children: classeur.children,
                    });
                  });
                }
              }
            });
            this.classements = _.sortBy(mappedResponse, 'label');
          }
          this.loading = false;
        },
        error: (error: HttpErrorResponse) => {
          console.error('Error : ', error);
        },
      });
  }

  public onClassementSelect(event): void {
    switch (event.node.type) {
      case 'classement':
        this.selectedClassement = event.node;
        this.selectedNode = event.node;
        this.selectedObjetClassement = {
          classementId: event.node.data,
          classeurId: null,
          chemiseId: null,
        };
        this.selectedNode.expanded = true;
        break;
      case 'classeur':
        this.selectedClasseur = event.node;
        this.selectedClasseur.expanded = true;
        this.selectedObjetClassement = {
          classementId: event.node.classementId,
          classeurId: event.node.data,
          chemiseId: null,
        };
        break;
      case 'chemise':
        this.selectedChemise = event.node;
        this.selectedObjetClassement = {
          classementId: event.node.classementId,
          classeurId: event.node.classeurId,
          chemiseId: event.node.data,
        };
        break;
    }
  }

  expandAll(): void {
    this.classements.forEach((node) => {
      this.expandRecursive(node, true);
    });
  }

  collapseAll(): void {
    this.classements.forEach((node) => {
      this.expandRecursive(node, false);
    });
  }

  private expandRecursive(node: TreeNode, isExpand: boolean): void {
    node.expanded = isExpand;
    if (node.children) {
      node.children.forEach((childNode) => {
        this.expandRecursive(childNode, isExpand);
      });
    }
  }

  onSubmit(): void {
    const data = {
      classementId: this.selectedClassement && this.selectedClassement !== undefined ? +this.selectedClassement.data : null,
      classeurId: this.selectedClasseur && this.selectedClasseur !== undefined ? +this.selectedClasseur.data : null,
      chemiseId: this.selectedChemise && this.selectedChemise !== undefined ? +this.selectedChemise.data : null,
    };
    this.courrier.classementId = data.classementId;
    this.courrier.classeurId = data.classeurId;
    this.courrier.chemiseId = data.chemiseId;
    this.closeClassificationSearchModal.emit(this.advancedMode ? this.selectedObjetClassement : data);
  }
}
